import { Popover } from "antd";
import styles from "./style.module.less";
import { getDateTime } from "../../utils/format";

const OrderLatestNote = ({ note }) => {
  if (!note?.note) return "-";

  const popoverContent = (
    <div className={styles.popoverContent}>
      <div className={styles.popoverNote}>{note.note}</div>
      <div className={styles.footer}>
        <span className={styles.footerAuthor}>{note.userName ?? ""}</span>
        <span className={styles.footerDate}>{getDateTime(note.updatedAt)}</span>
      </div>
    </div>
  );

  return (
    <Popover content={popoverContent} trigger="hover">
      <div className={styles.container}>
        <div className={styles.note}>{note.note}</div>
        <div className={styles.author}>{note.userName ?? ""}</div>
      </div>
    </Popover>
  );
};

export default OrderLatestNote;
